import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'alarmProbableCause' })
export class AlarmProbableCausePipe implements PipeTransform {

  readonly probableCauseMap = {
    0:  'Other',
    1:  'Adapter Error',
    2:  'Application Subsystem Failure',
    3:  'Bandwidth Reduced',
    4:  'Call Establishment Error',
    5:  'Communications Protocol Error',
    6:  'Communications Subsystem Failure',
    7:  'Configuration or Customization Error',
    8:  'Congestion',
    9:  'Corrupt Data',
    10: 'CPU Cycles Limit Exceeded',
    11: 'Data Set or Modem Error',
    12: 'Degraded Signal',
    13: 'Dte Dce Interface Error',
    14: 'Enclosure Door Open',
    15: 'Equipment Malfunction',
    16: 'Excessive Vibration',
    17: 'File Error',
    18: 'Fire Detected',
    19: 'Flood Detected',
    20: 'Framing Error',
    21: 'Heating Vent Cooling System Problem',
    22: 'Humidity Unacceptable',
    23: 'Input Output Device Error',
    24: 'Input Device Error',
    25: 'Lan Error',
    26: 'Leak Detected',
    27: 'Local Node Transmission Error',
    28: 'Loss of Frame',
    29: 'Loss of Signal',
    30: 'Material Supply Exhausted',
    31: 'Multiplexer Problem',
    32: 'Out of Memory',
    33: 'Output Device Error',
    34: 'Performance Degraded',
    35: 'Power Problem',
    36: 'Pressure Unacceptable',
    37: 'Processor Problem',
    38: 'Pump Failure',
    39: 'QueueSize Exceeded',
    40: 'Receive Failure',
    41: 'Receiver Failure',
    42: 'Remote Node Transmission Error',
    43: 'Resource At or Nearing Capacity',
    44: 'Response Time Execessive',
    45: 'Retransmission Rate Excessive',
    46: 'Software Error',
    47: 'Software Program Abnormally Terminated',
    48: 'Software Program Error',
    49: 'Storage Capacity Problem',
    50: 'Temperature Unacceptable',
    51: 'Threshold Crossed',
    52: 'Timing Problem',
    53: 'Toxic Leak Detected',
    54: 'Transmit Failure',
    55: 'Transmitter Failure',
    56: 'Underlying Resource Unavailable',
    57: 'Version Mismatch',
    58: 'Authentication Failure',
    59: 'Breach of Confidentiality',
    60: 'Cable Tamper',
    61: 'Delayed Information',
    62: 'Denial of Service',
    63: 'Duplicate Information',
    64: 'Information Missing',
    65: 'Information Modification Detected',
    66: 'Information Out of Sequence',
    67: 'Intrusion Detection',
    68: 'Key Expired',
    69: 'Non Repudiation Failure',
    70: 'Out of Hours Activity',
    71: 'Out of Service',
    72: 'Procedural Error',
    73: 'Unauthorized Access Attempt',
    74: 'Unexpected In formation'
  };

  transform(probableCauseId: number): string {
    return this.probableCauseMap[probableCauseId];
  }
}
